module.exports = new __parcel__URL__("up-down.9c5a4c4d.svg").toString();